<template>
  <div class="flex flex-col items-center">
    <RegisterHero title="Registreren als professional" />
    <div class="flex w-full justify-center">
      <div class="max-w-3xl grow px-6">
        <NuxtPage />
      </div>
    </div>
  </div>
</template>
